import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { Dialog, DialogTitle, Button, DialogActions, DialogContent, DialogContentText } from '@material-ui/core';

import If from '../condicional/if'
import { toggleShowDialog } from '../../store/actions/dialog'

const DialogAlert = props => {

    const { idDialogShow } = props;

    return (
        <Dialog
            id={'1'}
            fullScreen={props.fullScreen || false}
            fullWidth={props.fullWidth || true}
            maxWidth={props.maxWidth || 'sm'}
            open={props.openDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.children}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <If test={props.okButton}>
                    <Button
                        type={props.okButtonType}
                        onClick={() => props.okButtonClick(idDialogShow)}
                        variant='contained'
                        color='primary'
                        autoFocus
                        >
                        {props.labelOkButton}
                    </Button>
                </If>
                <If test={props.cancelButton}>
                    <Button
                        variant='contained'
                        color="secondary"
                        onClick={props.cancelButtonClick}
                    >
                        {props.labelCancelButton}
                    </Button>
                </If>
            </DialogActions>
        </Dialog>
    )
}

const mapStateToProps = state => ({ idDialogShow: state.dialog.idDialogShow })
const mapDispatchToProps = dispatch => bindActionCreators({ toggleShowDialog }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(DialogAlert)